"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
    createStore
    This is imported into app to create new store and provide proper typings.
*/

var createStore = function createStore(storeData, object) {
  var _object$options;

  var store = {
    data: storeData,
    scope: object === null || object === void 0 ? void 0 : (_object$options = object.options) === null || _object$options === void 0 ? void 0 : _object$options.context
  };
  return store;
};

var _default = createStore;
exports["default"] = _default;
module.exports = exports["default"];